import React from 'react';
import Anime from 'react-anime';
import CustomScroll from 'react-custom-scroll';
import BackToHomeBtn from './BackToHomeBtn';
import '../styles/customScroll.css';
import '../styles/AboutPage.css';

const AboutPage = props => {
  return(
    <Anime easing="easeOutCubic" opacity={[0, 1]} translateY={-30} duration={400} delay={300}>
      <div className="about-page">
          <BackToHomeBtn handleClick={props.returnBtn}/>
          <Anime easing="easeOutCubic" left={[-350, -150]} duration={500} delay={800}>
            <p className="page-tag">About Me</p>
          </Anime>
          <CustomScroll heightRelativeToParent="calc(100% - 20px)">
            <div className="page-content">
              <p>Hi there! <span className="hand-wave">👋</span></p>
              <h1>I'm Himanshu Barak</h1>
             
              <p>A recent graduate from Vellore Institute of Technology and a former 6 month SDE intern of Amazon.
                <br />
              I identify myself as a problem solver. I love building things that solves real world problems and also enjoy optimizng exists solutions.
              
              
              Other than coding I really like playing volleyball and reading fantasy fiction novels.</p>
             
              
            
              
              <h1>Skills</h1>
              <p>My current skill set includes <strong>JavaScript</strong>,<strong>Python</strong>, <strong>React JS</strong>, <strong>Node Js</strong>,<strong>AWS</strong>, <strong>C++</strong>, <strong>TypeScript</strong>, <strong>CSS</strong>, <strong>HTML</strong> ,<strong>Firebase</strong>,<strong>Mongo DB</strong> . <br /> I like to keep this list growing :)</p>
            <a href="https://drive.google.com/file/d/1uR3WN4b1WnjSokhpdyLv9KHZnh36XKgL/view"  target="_blank"><button  className="btn">Resume</button></a>
            </div>
          </CustomScroll>
      </div>
    </Anime>
  )
}

export default AboutPage;


// WEBPACK FOOTER //
// ./src/components/AboutPage.js